import useClinicalWorkflowsMessaging from '../../../widgets/messenger/hooks/useClinicalWorkflowsMessaging';
import mobxInjectSelect from 'common/utils/mobxInjectSelect';

type ClinicalWorkflowsProps = {};

type MobxProps = {
  clinicalWorkflowsAlertUsers: { orgToken: string; authKey: string; authSecret: string } | null;
  currentOrganizationId: string;
};

function ClinicalWorkflows({
  clinicalWorkflowsAlertUsers,
  currentOrganizationId,
}: ClinicalWorkflowsProps & MobxProps) {
  useClinicalWorkflowsMessaging(clinicalWorkflowsAlertUsers, currentOrganizationId);

  return (
    <iframe
      src="https://tigertext.github.io/ascend/?hideLeftNav=true"
      style={{ width: '100%', height: '100%', border: 'none' }}
      title="Clinical Workflows"
      allow="microphone"
    />
  );
}

export default mobxInjectSelect<ClinicalWorkflowsProps, MobxProps>({
  messengerStore: ['clinicalWorkflowsAlertUsers', 'currentOrganizationId'],
})(ClinicalWorkflows);
